import cn from "clsx";
import { useStores } from "@/models";
import AutoCode from "../AutoCode/code";
import style from "../../index.module.scss";
import cookieUtils from "@/utils/cookieUtils";
import CloseLine from "@/assets/icons/close_line.svg";
import LoadingIcon from "@/components/loadingIcon";
import { Button, Select, MenuItem, IconButton, FormControl, OutlinedInput, InputAdornment, DialogContent } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import UKToast from "@/components/UKToast";
import { getEncryptDefaultString, maskPhone } from "@/utils/helpers";
import { btnRedDisabled, btnCancelDisabled } from "../style";
import { InputStyle, SelectStyle, MenuProps } from "../style";
import { getTranslatedCookiesSettings } from "@/app/csr-src/data/consts/accountEnum";
import { judgeNewOrOldUserFn, splitAndProcess } from "@/app/login/utils/index";
import { loginOrRegisterByOTP } from "@/apis/login/login.api";
import { updateEmailApi, getCountryListApi } from "@/app/csr-src/apis/profile/accountSetting.api";
import { useTranslation } from "@/i18n/client";
import UKBlackLoading from "@/components/UKBlackLoading";
import UKPageError from "@/components/UKPageError";
import loginConfig from "@/constants/loginConfig";
import { forceSendCode, openRiskControl } from "@/utils/login/riskControlUtil";
import LoginDialog from "@/app/login/components/Dialog/index";
import ReceiveTheCodeDom from "@/app/login/components/ReceiveTheCodeTips/ReceiveTheCodeDom";

const AddPhone = React.forwardRef(({ pageFlag, jumpToDialog, freezeAccount, continueFn, handleClose }: any, ref) => {
  const { loginStore } = useStores();

  AddPhone.displayName = "AddPhone";
  const { t } = useTranslation();
  // 使用翻译后的设置
  const { AccountTypeEnum } = getTranslatedCookiesSettings(t);
  const [seconds, setSeconds] = useState(0);
  const [codeError, setCodeError] = useState(""); // 错误提示
  const [resendCode, setResendCode] = useState("60s"); // 倒计时数字
  const [completeCodes, setCompleteCodes] = useState(""); // 输入成功后的验证码 进行 校验验证码
  const [isShowVerificationInput, setIsShowVerificationInput] = useState(true); // 是否显示验证码输入框
  const [secondsFlag, setSecondsFlag] = useState(false); // 重复新发送验证码按钮状态
  const [addPhoneDisabled, setBtnDisabled] = useState(true); // 邮箱添加按钮是否禁用
  const [sendCodeBtnDisabled, setSendCodeBtnDisabled] = useState(false);
  const [idPrefix, setIdPrefix] = useState<any>(44); // 手机号国家标识
  const [error, setError] = useState<string | null>(""); // 错误提示
  const [inputVal, setInputVal] = useState<any>(""); // 输入框的值
  const [isLoading, setIsLoading] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [sliderFail, setSliderFail] = useState(false); // 滑块加载失败
  const [sliderLoading, setSliderLoading] = useState(false); // 滑块是否加载中
  const tryAgainFunc = useRef(()=>{});// 滑块加载失败回调
  const stepCodeRef = useRef<string | null>(null);
  const countryList = useRef<any>(null);
  const Timer = useRef<any>(null);
  const secondsLeft = useRef<any>(60);
  const urlExtParams = splitAndProcess();
  const [receiveTheCodeOpen, setReceiveTheCodeOpen] = useState(false); // 是否打开没有验证码的弹框；

  // 输入框的值改变
  useEffect(() => {
    if (inputVal && inputVal.trim() !== "" && inputVal.length >= 6) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
    setError("");
  }, [inputVal]);

  useEffect(() => {
    getCountryList();
  }, []);
  // 倒计时方法
  const updateTimer = () => {
    setResendCode(`${secondsLeft.current}s`);
    Timer.current = setInterval(() => {
      secondsLeft.current--;
      if (secondsLeft.current > 0) {
        setSeconds(secondsLeft.current);
        setResendCode(`${secondsLeft.current}s`);
      } else {
        setResendCode(``);
        setSecondsFlag(false);
        setSendCodeBtnDisabled(false);
        setSeconds(secondsLeft.current);
        clearInterval(Timer.current);
      }
    }, 1000);
  };
  // 风控相关的逻辑
  useEffect(() => {
    // 验证的时候 不需要输入手机号弹框
    if (freezeAccount?.scene === loginConfig.RiskEnum.SCENE_AUTHENTICATION) {
      setIsShowVerificationInput(false);
      openPhoneRiskControl(true);
    }
  }, [freezeAccount]);
  // 点击编辑按钮 返回上一页
  const phoneEdit = () => {
    setIsShowVerificationInput(true);
    clearInterval(Timer.current);
    setBtnDisabled(false);
  };
  // Sign In
  const phoneSignInSubmit = async () => {
    setIsLoading(true);
    if (isShowVerificationInput) {
      // 发送验证码
      if (inputVal && inputVal.trim() !== "") {
        if (/^\d+$/.test(inputVal) && inputVal.length < 13) {
          setIsShowVerificationInput(false);
          openPhoneRiskControl();
        } else {
          setIsLoading(false);
          setError(t("settings.phoneNumberInfo.incorrectPhoneNumber"));
        }
      }
    } else {
      // 添加 -- 修改 手机号
      if (freezeAccount?.isRiskControlAccount) {
        // 如果是风控账号 过来的情况下
        freezeAccountFn();
      } else {
        updatePhone();
      }
    }
  };
  // 打开风控
  const openPhoneRiskControl = async (forceSend:  boolean = false) => {
    const { riskType } = await judgeNewOrOldUserFn({
      type: "phone",
      identifier: inputVal as string,
      idPrefix: "+" + idPrefix,
    });
    const sessionParam = {
      riskType,
      mobile: getEncryptDefaultString(inputVal as string),
      mobilePrefix: idPrefix,
    }
    const riskData = {
      t,
      riskType,
      sessionParam,
      isPhone: true,
      action: loginConfig.CaptchaActionEnum.SET_PHONE_EMAIL,
      onSliderLoading,
      onCancelLoading,
      onSliderSuccess,
      onSliderFail,
      onSliderCancel,
      onSliderLoad,
      onSendSuccess,
      onSendFail,
      onCodeAlreadySend,
    }
    const requestData: any = {
      riskType,
      scene: getSendCodeScene(),
      stepCode: freezeAccount?.previousStepCode || null,
      identifier: freezeAccount?.scene === loginConfig.RiskEnum.SCENE_AUTHENTICATION ? freezeAccount?.identifier : inputVal,
      idPrefix: freezeAccount?.scene === loginConfig.RiskEnum.SCENE_AUTHENTICATION ? freezeAccount?.idPrefix : "+" + idPrefix,
      otpType: loginConfig.LoginTypeEnum.MOBILE,
      captchaAction: loginConfig.CaptchaActionEnum.SET_PHONE_EMAIL,
      ...loginStore.loginCommonParams
    };
    if(forceSend) {
      forceSendCode(riskData, requestData);
    }
    else{
      openRiskControl(riskData, requestData);
    }
    tryAgainFunc.current = () => openPhoneRiskControl(forceSend);
  }
  const getSendCodeScene = () => {
    // 如果被风控的时候发送验证码需要 填入风控的场景标识;
    if (freezeAccount?.isRiskControlAccount) {
      return freezeAccount?.scene;
    } 
    return pageFlag === AccountTypeEnum.ADD_PHONE ? loginConfig.VerifyCodeSceneEnum.BIND_MOBILE_OR_EMAIL : loginConfig.VerifyCodeSceneEnum.MODIFY_MOBILE_NEW;
  }
  // 滑块加载中
  const onSliderLoading = () => {
    setIsLoading(false);
    setSliderFail(false);
    setSliderLoading(true);
  }
  // 滑块取消加载
  const onCancelLoading = () => {
    setSliderLoading(false);
  }
  // 滑块验证成功
  const onSliderSuccess = () => {
    setIsLoading(false);
    setSliderFail(false);
    setSliderLoading(false);
  }
  // 滑块加载失败
  const onSliderFail = () => {
    setSliderFail(true);
    setIsLoading(false);
    setSliderLoading(false);
  }
  // 滑块关闭
  const onSliderCancel = () => {
    setIsLoading(false);
    setSliderLoading(false);
  }
  // 滑块加载完成
  const onSliderLoad = () => {
    setSliderFail(false);
    setIsLoading(false);
    setSliderLoading(false);
  }
  // 验证码发送成功
  const onSendSuccess = async (code: string) => {
    stepCodeRef.current = code;
    cookieUtils.setSessionStorage(loginConfig.LOGIN.STEP_CODE, code);
    enterCountdown();
    setIsLoading(false);
  }
  // 验证码发送失败
  const onSendFail = async (msg: string) => {
    setIsLoading(false);
    setError(msg || t("settings.phoneNumberInfo.incorrectPhoneNumber"));
  }
  // 验证码已经发送
  const onCodeAlreadySend = async (msg: string) => {
    setIsLoading(false);
    const stepCode = cookieUtils.getSessionStorage(loginConfig.LOGIN.STEP_CODE);
    if (stepCode) {
      enterCountdown();
    } else {
      setError(msg || t("settings.phoneNumberInfo.incorrectPhoneNumber"));
      UKToast.show({ content: msg, icon: "error" });
    }
  }
  // 进入60s倒计时
  const enterCountdown = async () => {
    secondsLeft.current = 60;
    setSeconds(60);
    setResendCode("60s");
    setSendCodeBtnDisabled(true);
    updateTimer();
    setSecondsFlag(true);
  }
  // 被风控的时候进行验证风控
  const freezeAccountFn = async () => {
    const extParams = freezeAccount?.userType === loginConfig.LOGIN.NEW_USER ? { extension: JSON.stringify({ ...urlExtParams }) } : null;
    const [err, res]: any = await loginOrRegisterByOTP({
      // 如果是验证的话 需要用传入的邮箱 , 否则使用输入的;
      verifyCode: completeCodes, // 验证码
      scene: freezeAccount?.scene, // 风控场景
      stepCode: stepCodeRef.current,
      otpType: loginConfig.LoginTypeEnum.MOBILE, // 邮箱 - 类型
      previousStepCode: freezeAccount?.previousStepCode, // 风控账号的stepCode
      identifier: freezeAccount?.scene === loginConfig.RiskEnum.SCENE_AUTHENTICATION ? freezeAccount?.identifier : inputVal,
      idPrefix: freezeAccount?.scene === loginConfig.RiskEnum.SCENE_AUTHENTICATION ? freezeAccount?.idPrefix : "+" + idPrefix,
      ...extParams, // 地推 邀请码 - 参数
      ...loginStore.loginCommonParams
    });
    setIsLoading(false);
    if (!res?.success) {
      UKToast.show({ icon: "error", content: res?.msg || t("phonecode.operationFail") });
      return;
    }
    stepCodeRef.current = null;
    cookieUtils.clearSessionStorage(loginConfig.LOGIN.STEP_CODE);
    continueFn?.({ success: true });
  };

  // 正常添加或者修改手机号
  const updatePhone = async () => {
    const [err, res]: any = await updateEmailApi({
      otpType: 2,
      identifier: inputVal,
      idPrefix: "+" + idPrefix,
      optVerifyCode: completeCodes,
      stepCode: stepCodeRef.current,
    });
    if (res && res.success) {
      stepCodeRef.current = null;
      cookieUtils.clearSessionStorage(loginConfig.LOGIN.STEP_CODE);
      jumpToDialog?.({
        type: AccountTypeEnum.PHONE_SUCCESS,
        flag: pageFlag == AccountTypeEnum.ADD_PHONE ? AccountTypeEnum.ADD_PHONE : AccountTypeEnum.CHANGE_PHONE,
        successText: t("settings.emailInfo.verifySuccessfully")
      });
      setIsLoading(false);
    } else {
      UKToast.show({ icon: "error", content: res.msg || t("settings.phoneNumberInfo.incorrectPhoneNumber") });
      //   setCodeError(res.msg || t("settings.phoneNumberInfo.incorrectPhoneNumber"));
      setIsLoading(false);
    }
  };
  const CancelFn = () => {
    // 区分风控场景过来的直接关闭弹窗
    if (freezeAccount?.isRiskControlAccount) {
      handleClose?.();
      return;
    }
    jumpToDialog?.({
      type: "accountSecurity",
      flag: "accountSecurity",
    });
  };
  const getCountryList = async () => {
    const [err, res] = await getCountryListApi();
    if (res?.success) {
      countryList.current = res?.data?.internationalData?.mobileLocations;
      const v = res?.data?.internationalData;
      v?.defaultMobileLocations && v?.defaultMobileLocations.length > 0 && setIdPrefix(parseFloat(v?.defaultMobileLocations[0].code));
    }
    setIsPageLoading(false);
  };
  
  if(sliderFail){
    return <UKPageError
      clickTryAgain={() => {tryAgainFunc.current && tryAgainFunc.current()}}
      text={t('common.pageStatus.error')}
      btnText={t('common.btnText.tryAgain')}
    />
  }

  return (
    <>
      {isPageLoading ? (
        <div className={style.setPhoneLoading}>
          <LoadingIcon /> {` ${t("common.loading")}`}
        </div>
      ) : (
        <div className={cn(style.email__wrap, { [style.non_interactive]: sliderLoading })}>
          

          {/* 手机号输入框 */}
          {isShowVerificationInput && (
            <>
              <div className={`${style.title__text} ${style.title__phone__text}`}>
                { freezeAccount?.isRiskControlAccount ? t("settings.securityVerificationTips") :
                  (pageFlag === AccountTypeEnum.CHANGE_PHONE ? t("settings.phoneNumberInfo.afterPhoneLogin") : t("settings.phoneNumberInfo.afterPhoneLoginAdd"))
                }
              </div>
              <FormControl error={!!error} sx={{ ...InputStyle, margin: "10px 0" }} variant="outlined">
                <OutlinedInput
                  type="text"
                  value={inputVal}
                  placeholder={t("settings.phoneNumberInfo.enterPhoneNumber")}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setInputVal(e.target.value)}
                  startAdornment={
                    <InputAdornment position="start">
                      <Select
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        autoWidth
                        value={idPrefix}
                        onChange={(event: any) => setIdPrefix(Number(event.target.value))}
                        MenuProps={MenuProps as any}
                        sx={{
                          ...SelectStyle,
                        }}
                      >
                        {countryList.current && countryList.current.length > 0 ? (
                          countryList.current.map((item: any, index: number) => {
                            return (
                              <MenuItem key={index} value={parseFloat(item.code)}>
                                {item.name}({item.code})
                              </MenuItem>
                            );
                          })
                        ) : (
                          <MenuItem value={44}>GB(+44)</MenuItem>
                        )}
                      </Select>
                    </InputAdornment>
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      {inputVal && (
                        <IconButton
                          onClick={() => {
                            setError("");
                            setInputVal("");
                          }}
                        >
                          <CloseLine />
                        </IconButton>
                      )}
                    </InputAdornment>
                  }
                />
                {/* {!!error && <FormHelperText>{error}</FormHelperText>} */}
              </FormControl>
              {!!error && <div className={style.error__text}>{error}</div>}
            </>
          )}
          {/* 验证码盒子 */}
          {!isShowVerificationInput && (
            <>
              <div className={style.title__text}>
                {t("settings.phoneNumberInfo.weHaveSentCode")}{" "}
                {!freezeAccount?.isRiskControlAccount ? maskPhone(inputVal as string) : freezeAccount?.identifier}{" "}
                {
                  // 如果是风控禁止进行编辑手机号
                  !freezeAccount?.isRiskControlAccount && (
                    <>
                      <span className={style.edit} onClick={phoneEdit}>
                        {t("common.btnText.edit")}
                      </span>
                    </>
                  )
                }
              </div>
              <AutoCode
                error={codeError}
                onValueChange={(codes: string) => {
                  setCompleteCodes(codes);
                  if (codes.length != 6) {
                    setBtnDisabled(true);
                  } else {
                    setBtnDisabled(false);
                  }
                }}
              />
              <div
                className={style.receive_the_code}
                onClick={() => {
                  setReceiveTheCodeOpen(true);
                }}
              >
                {t("login.common.notReceive")}
              </div>
            </>
          )}
          {/* submit 点击按钮 */}
          <div className={style.btn_emailVerify_wrap}>
            <Button
              disableElevation
              variant="contained"
              disabled={addPhoneDisabled || isLoading}
              startIcon={isLoading ? <LoadingIcon /> : null}
              onClick={phoneSignInSubmit}
              sx={{
                ...btnRedDisabled,
              }}
            >
              {isShowVerificationInput && t("checkout.common.continue")}
              {!isShowVerificationInput && t("settings.emailInfo.verify")}
            </Button>
            <Button
              disableElevation
              variant="contained"
              disabled={sendCodeBtnDisabled}
              onClick={() => {
                if (isShowVerificationInput) {
                  CancelFn();
                } else {
                  if (!secondsFlag) {
                    openPhoneRiskControl();
                  }
                }
              }}
              sx={{
                ...btnCancelDisabled,
              }}
            >
              {isShowVerificationInput && t("cart.cancel")}
              {!isShowVerificationInput && secondsFlag && seconds != 0 ? t("settings.emailInfo.resendCode") + " " + resendCode : ""}
              {!isShowVerificationInput && seconds == 0 && t("settings.emailInfo.resend")}
            </Button>
          </div>
        </div>
      )}
      {
        sliderLoading && (
          <div className={style.loading_overlay}>
            <UKBlackLoading />
          </div>
        )
      }
      {/* 手机 没有收到验证码 弹框 */}
      <LoginDialog
        open={receiveTheCodeOpen}
        showCloseBtn={true}
        onClose={(e: React.MouseEvent<HTMLButtonElement>, r: string) => setReceiveTheCodeOpen(false)}
        sx={{
          "& .MuiDialog-paper": {
            minWidth: "500px",
            maxHeight: "380px",
            borderRadius: "12px",
          },
        }}
      >
        <DialogContent>
          <ReceiveTheCodeDom closeDialog={() => setReceiveTheCodeOpen(false)} />
        </DialogContent>
      </LoginDialog>
    </>
  );
});

export default AddPhone;
